export const BrandTitle = ({ tle }) => {
  return (
    <div className="projects-opening-brand-title">
      <div>
        <h1>{tle}</h1>
      </div>
    </div>
  );
};
